<div><img src="../../../assets/img/ibex-logo-text-new-new.png"/></div>

<b *ngIf="content?.title">{{content.title}}</b>

<p *ngIf="content?.message">{{content.message}}</p>

<button (click)="navigateToLogin()" class="alternative-login" color="accent" mat-raised-button>{{'login.reset.back' | translate}}</button>
